/**
 * Normalize line endings in the stream received by the terminal.
 *
 * Firmware output can use LF, CRLF, or split CR/LF across socket chunks.
 * xterm keeps the current column for a bare LF, so line-oriented LF output
 * must be preceded by a carriage return before it is rendered.
 */
export function createTelnetOutputNormalizer() {
  let pendingCarriageReturn = false;

  return {
    push(chunk) {
      if (chunk === undefined || chunk === null || chunk === '') return '';

      const input = String(chunk);
      let output = '';
      let index = 0;

      if (pendingCarriageReturn) {
        pendingCarriageReturn = false;
        if (input[0] === '\n') {
          output += '\r\n';
          index = 1;
        } else {
          output += '\r';
        }
      }

      for (; index < input.length; index += 1) {
        const character = input[index];

        if (character === '\r') {
          if (input[index + 1] === '\n') {
            output += '\r\n';
            index += 1;
          } else if (index === input.length - 1) {
            // Wait for the next chunk so a split CRLF is emitted once.
            pendingCarriageReturn = true;
          } else {
            // A bare CR is meaningful terminal control input (for example,
            // progress/status output), so preserve it.
            output += '\r';
          }
        } else if (character === '\n') {
          output += '\r\n';
        } else {
          output += character;
        }
      }

      return output;
    },

    flush() {
      if (!pendingCarriageReturn) return '';
      pendingCarriageReturn = false;
      return '\r';
    },
  };
}
